jQuery(function($){
    

    let navMenu = $('.nav-menu-popup');

    navMenu.find('.nav-menu-popup__close').on('click', function(){
        navMenu.removeClass('active');
        $('.site-overlay').removeClass('active');
    });

    $('.open-mobile-menu').on('click', function(e){
        e.stopPropagation();
        navMenu.addClass('active');
        $('.site-overlay').addClass('active');
    });

    $('.nav-menu-popup').on('click', function(e){
        e.stopPropagation();
    });

    $(window).on('click', function(e){
        navMenu.removeClass('active');
        $('.site-overlay').removeClass('active');
    });


    let menu = $('.standard-menu-mobile');
    let bigMenus = menu.find('.big-menu');
    let allCats = $('.nav-menu-popup__all-cats');
    
    // First layer
    menu.find('.has-sub:not(".active") > a, .has-sub:not(".active") > span').on('click', menuClick);

    function menuClick(e){
        e.preventDefault();
        $(this).off('click');
        $(this).parent().find('ul').eq(0).addClass('active');

        // Hide other big menus, so that just this one opens
        if ($(this).parent().hasClass('big-menu')){
            bigMenus.addClass('hide');
            $(this).parent().removeClass('hide');
            $(this).parent().addClass('active');
            console.log($(this).parent().find('ul'));
            $(this).parent().find('.depth-1').eq(0).addClass('active'); // Open the first sub menu
            $(this).parent().find('.depth-0 a, .depth-0 span').eq(0).off('click');
            allCats.addClass('active');
            
        }
    }

    // Back to main menu 
    allCats.on('click', function(e){
        bigMenus.removeClass('hide');
        bigMenus.removeClass('active');
        bigMenus.find('ul').removeClass('active');
        allCats.removeClass('active');

        menu.find('.has-sub:not(".active") > a, .has-sub:not(".active") > span').on('click', menuClick);
    });



});